export const SYSTEM_SIZE_LIMIT = 25;
export const STRING_INVERTER_DROPDOWN_TYPE = "String Inverter";
export const MICRO_INVERTER_DROPDOWN_TYPE = "Micro Inverter";
export const SALES_MODE_CONSTANT = {

    RESET_STATE: {
        showModelsBtnsActive: false,
        drawRoofBtnActive: false,
        flatRoofBtnActive: false,
        powerGazeboBtnActive: false,
        groundMountBtnActive: false,
        obstructionBtnActive: false,
        panelsBtnActive: false,
        showToolbar: false,
        selectedModel: null,
        showEdgeProperties: false,
        showCommonDropdown: true,
        showObstructionTypeCard: false,
        showInputFiledsCard: false,
        showDrawRoofInputsCard: false,
        showObstructionDrawInputsCard: false,
        showObstructionRectangleInputsCard: false,
        showObstructionCylinderInputsCard: false,
        showObstructionTreeInputsCard: false,
        disabledBackToLeadBtn: false,
        disabledPrevBtn: false,
        disabledNextBtn: false,
        disabledSubmitBtn: false,
        disabledSaveBtn: true,
        disabledCancelBtn: true,
        disabledUpdateBtn: false,
        showGenerationCard: false,
        showCompleteBtn: false,
        showGuidanceMsg: false,
        manageComponentActive: false,
        gazeboEnabled: false,
        toggleObt: false,
    },

    RESET_STATE_AFTER_FILLFACE: {
        showModelsBtnsActive: false,
        drawRoofBtnActive: false,
        flatRoofBtnActive: false,
        powerGazeboBtnActive: false,
        groundMountBtnActive: false,
        obstructionBtnActive: false,
        panelsBtnActive: false,
        showToolbar: false,
        selectedModel: 'Add Modules',
        showEdgeProperties: false,
        showCommonDropdown: true,
        showObstructionTypeCard: false,
        showInputFiledsCard: false,
        showDrawRoofInputsCard: false,
        showObstructionDrawInputsCard: false,
        showObstructionRectangleInputsCard: false,
        showObstructionCylinderInputsCard: false,
        showObstructionTreeInputsCard: false,
        disabledBackToLeadBtn: false,
        disabledPrevBtn: false,
        disabledNextBtn: false,
        disabledSubmitBtn: false,
        disabledSaveBtn: false,
        disabledCancelBtn: true,
        disabledUpdateBtn: false,
        showGenerationCard: true,
        showCompleteBtn: false,
        showGuidanceMsg: false,
        manageComponentActive: false,
        gazeboEnabled: false,
        toggleObt: false,
        isCopying: false,
    },

    NEXT_BUTTON_CONSTANT: {

        DRAWROOF_TO_OBSTRUCTIONS: {
            showModelsBtnsActive: true,
            obstructionBtnActive: true,
            showCommonDropdown: true,
            cannotComplete : false,
            modelType: 'initialObstruction',

        },

        OBSTRUCTIONS_TO_PANELS: {
            showModelsBtnsActive: true,
            panelsBtnActive: true,
            showCommonDropdown: true,
            modelType: 'initialPanels',
            disabledSaveBtn: false,
        }
    },

    PREVIOUS_BUTTON_CONSTANT: {

        OBSTRUCTION_TO_DRAWROOF: {
            showModelsBtnsActive: true,
            drawRoofBtnActive: true,
            powerGazeboBtnActive: true,
            flatRoofBtnActive: true,
            groundMountBtnActive: true,
            showCommonDropdown: true,
            disabledPrevBtn: true,
            cannotComplete : false,
            modelType: 'drawRoof',
        },

        PANELS_TO_OBSTRUCTIONS: {
            obstructionBtnActive: true,
            showGenerationCard: false,
            panelsBtnActive: false,
            showModelsBtnsActive: true,
            showSelectedObstructions: true,
            showCommonDropdown: true,
            modelType: 'initialObstruction',
        }
    },

    MODEL_TYPE_BUTTONS_CONSTANT: {

        COMMON_FOR_ALL_BUTTONS: {
            showToolbar: true,
            showObstructionTypeCard: true,
            disabledNextBtn: true,
            toggleObt: false,
            showCommonDropdown: false,
            disabledPrevBtn: true,
        },

        DRAWROOF_BUTTON: {
            modelType: 'drawRoof',
            selectedModel: 'Draw Roof',
            showCompleteBtn: true,
            disabledCancelBtn: false,
        },

        FLATROOF_BUTTON: {
            modelType: 'flatRoof',
            selectedModel: 'Flat Roof',
            showCompleteBtn: true,
            disabledCancelBtn: false,
        },

        INVERTER_BUTTON: {
            modelType: 'inverter',
            selectedModel: 'Inverter',
            showCompleteBtn: false,
            showInputFiledsCard: true,
        },

        GROUND_MOUNT_BUTTON: {
            modelType: 'groundMount',
            selectedModel: 'GroundMount',
            showCompleteBtn: true,
            disabledCancelBtn:false,
        },

        FILLFACE_MODE_BUTTON: {
            modelType: 'fillFaceMode',
            selectedModel: 'FillFace',
            showCompleteBtn: true,
            disabledCancelBtn:false,
        },

        GAZEBO_BUTTON: {
            modelType: 'powerGazebo',
            selectedModel: 'PowerGazebo',
            showCompleteBtn: false,
            disabledCancelBtn: false,
        },

        PATIO_BUTTON: {
            modelType: 'powerPatio',
            selectedModel: 'PowerPatio',
            showCompleteBtn: true,
            disabledCancelBtn: false,
        },

        OBSTRUCTIONS_BUTTON: {
            modelType: 'obstruction',
            selectedModel: 'Add Obstruction',
            showCompleteBtn: true,
            showObstructionTypeCard: true,
            disabledCancelBtn: false,
        },

        PANELS_BUTTON: {
            modelType: 'panels',
            showCommonDropdown: true,
            selectedModel: 'Add Modules',
            panelsBtnActive: true,
            showGenerationCard: true,
            manageComponentActive: true,
        }
    },

    MODEL_TYPE_ON_SELECTION: {

        COMMON_FOR_ALL_SELECTIONS: {
            showToolbar: true,
            showObstructionTypeCard: true,
            disabledNextBtn: true,
            toggleObt: false,
            showCommonDropdown: false,
            disabledPrevBtn: true,
            disabledCancelBtn: true,
        },

        DRAWROOF_SELECTION: {
            modelType: 'drawRoof',
            showEdgeProperties: true,
            showInputFiledsCard: true,
            selectedModel: 'Draw Roof',
        },

        FLATROOF_SELECTION: {
            modelType: 'flatRoof',
            showEdgeProperties: false,
            showInputFiledsCard: true,
            selectedModel: 'Flat Roof',
        },

        GAZEBO_SELECTION: {
            modelType: 'powerGazebo',
            selectedModel: 'PowerGazebo',
            showCommonDropdown: false,
        },

        GROUNT_MOUNT_SELECTION: {
            modelType: 'groundMount',
            selectedModel: 'GroundMount',
            manageComponentActive: true,
            showCommonDropdown: false,
        },

        PATIO_SELECTION: {
            modelType: 'powerPatio',
            selectedModel: 'PowerPatio',
            showCommonDropdown: false,
        },

        OBSTRUCTION_SELECTION: {
            modelType: 'obstruction',
            selectedModel: 'Add Obstruction',
            showInputFiledsCard: true,
        },

        PANEL_SELECTION: {
            disabledCancelBtn: true,
            manageComponentActive: true,
            showCompleteBtn: false,
            showModelsBtnsActive: false,
            showToolbar: false,
            showObstructionTypeCard: false,
            showCommonDropdown: false,
        }

        // POLYGON_OBSTRUCTION_SELECTION: {
        //     modelType: 'obstruction',
        //     selectedModel: 'Add Obstruction',
        //     showInputFiledsCard: true,
        // },

        // CYLINDER_OBSTRUCTION_SELECTION: {
        //     modelType: 'obstruction',
        //     selectedModel: 'Add Obstruction',
        //     showInputFiledsCard: true,
        // },

        // TREE_OBSTRUCTION_SELECTION: {
        //     modelType: 'obstruction',
        //     selectedModel: 'Add Obstruction',
        //     showInputFiledsCard: true,
        // },


    },

    UPDATE_BUTTON_CONSTANT: {

        DRAWROOF_SAVE_BTN: {
            showCommonDropdown: true,
            showModelsBtnsActive: true,
            powerGazeboBtnActive: true,
            drawRoofBtnActive: true,
            flatRoofBtnActive: true,
            groundMountBtnActive: true,
            disabledSaveBtn: false,
            disabledPrevBtn: true,
            disabledNextBtn: true,
        },

        FLATROOF_SAVE_BTN: {
            showCommonDropdown: true,
            showModelsBtnsActive: true,
            drawRoofBtnActive: true,
            powerGazeboBtnActive: true,
            flatRoofBtnActive: true,
            groundMountBtnActive: true,
            disabledSaveBtn: false,
            disabledPrevBtn: true,
            disabledNextBtn: true,
        },
        
        INVERTER_SAVE_BTN: {
            showCommonDropdown: true,
            showModelsBtnsActive: true,
            drawRoofBtnActive: true,
            powerGazeboBtnActive: true,
            flatRoofBtnActive: true,
            groundMountBtnActive: true,
            disabledSaveBtn: false,
            disabledPrevBtn: true,
            disabledNextBtn: true,
        },
        GROUND_MOUNT_SAVE_BTN: {
            showCommonDropdown: true,
            showModelsBtnsActive: true,
            powerGazeboBtnActive: true,
            drawRoofBtnActive: true,
            flatRoofBtnActive: true,
            groundMountBtnActive: true,
            disabledSaveBtn: false,
            disabledPrevBtn: true,
            disabledNextBtn: true,
        },

        GAZEBO_SAVE_BTN: {
            showCommonDropdown: true,
            showModelsBtnsActive: true,
            powerGazeboBtnActive: true,
            drawRoofBtnActive: true,
            flatRoofBtnActive: true,
            groundMountBtnActive: true,
            disabledSaveBtn: false,
            disabledPrevBtn: true,
            disabledNextBtn: true,
        },

        OBSTRUCTIONS_SAVE_BTN: {
            showCommonDropdown: true,
            showModelsBtnsActive: true,
            obstructionBtnActive: true,
            disabledSaveBtn: false,
        },

        PANELS_SAVE_BTN: {
            showCommonDropdown: true,
            showModelsBtnsActive: true,
            panelsBtnActive: true,
            disabledSaveBtn: false,
            showGenerationCard: true,
        }


    }

}

export const GROUNT_MOUNT_TYPE = 'groundMount';
export const GROUND_MOUNT_SELECTED_TYPE = 'GroundMount';